import { useAppServices } from "hook/services";
import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Container,
  Divider,
  Grid,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
} from "@mui/material";
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'

import {
  CheckCircle as CheckCircleIcon,
  Person as PersonIcon,
  HelpOutline as HelpOutlineIcon,
} from "@mui/icons-material";

const index = () => {
  const AppService = useAppServices();
  const [roadmapData, setRoadmapData] = useState([]);

  const getData = async () => {
    const { response } = await AppService.roadmap.get({ toaster: false });

    if (response?.data) {
      const filteredData = response.data.filter(
        (item) => Array.isArray(item.roadmap_user_id) && item.roadmap_user_id.length > 0
      );

      const enrichedData = await Promise.all(
        filteredData.map(async (item) => {
          const userDetails = await Promise.all(
            item.roadmap_user_id.map(async (user_id) => {
              const { response } = await AppService.appusers.allappusers({ query: `id=${user_id}` });
              return response?.data || null;
            })
          );

          return {
            ...item,
            userDetails: userDetails.filter(Boolean),
          };
        })
      );

      setRoadmapData(enrichedData);
    } else {
      setRoadmapData([]);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const getStatusChip = (status) => {
    switch (status.toLowerCase()) {
      case "completed":
        return (
          <Chip
            icon={<CheckCircleIcon fontSize="small" />}
            label="Completed"
            color="success"
            variant="outlined"
            size="small"
          />
        );
      default:
        return (
          <Chip
            icon={<HelpOutlineIcon fontSize="small" />}
            label={status}
            color="default"
            variant="outlined"
            size="small"
            sx={{ pl: 0.5 }}
          />
        );
    }
  };

  return (
    <DashboardLayout>

      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
          Roadmap Applications
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          Explore the latest applications and their voters
        </Typography>

        <Grid container spacing={3} sx={{ mt: 2 }}>
          {roadmapData.map((app) => (
            <Grid item xs={12} md={12} key={app._id}>
              <Card elevation={3} sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                <CardContent sx={{ flexGrow: 1 }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography variant="h5" component="h2">
                      {app.name}
                    </Typography>
                    {getStatusChip(app.status)}
                  </Box>

                  {/* <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" color="text.secondary" component="div" dangerouslySetInnerHTML={{ __html: app.description }} />
                </Box> */}

                  <Divider sx={{ my: 2 }} />

                  <Grid container spacing={2} sx={{ mb: 2 }}>

                    <Grid item xs={6}>
                      <Typography variant="caption" color="text.secondary" display="block">
                        Created
                      </Typography>
                      <Typography variant="body2">{formatDate(app.createdAt)}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="text.secondary" display="block">
                        Updated
                      </Typography>
                      <Typography variant="body2">{formatDate(app.updatedAt)}</Typography>
                    </Grid>
                  </Grid>

                  {app.userDetails && app.userDetails.length > 0 && (
                    <>
                      <Divider sx={{ my: 2 }}>
                        <Chip label="Voters" size="small" />
                      </Divider>
                      <Paper elevation={0} sx={{ p: 1, bgcolor: "background.paper" }}>
                        <List dense>
                          {app.userDetails.reduce((rows, user, index) => {
                            if (index % 2 === 0) rows.push([user]); // start a new row
                            else rows[rows.length - 1].push(user); // add to current row
                            return rows;
                          }, []).map((pair, rowIndex) => (
                            <Box key={rowIndex} display="flex" gap={2} mb={2}>
                              {pair.map((user, index) => (
                                <ListItem key={index} sx={{ flex: 1, p: 0 }}>
                                  <ListItemAvatar>
                                    <Avatar sx={{ bgcolor: "primary.main" }}>
                                      <PersonIcon />
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={`${user.firstName} ${user.lastName}`}
                                    secondary={
                                      <>
                                        <Typography
                                          component="span"
                                          variant="body2"
                                          color="text.primary"
                                          display="block"
                                        >
                                          {user.email}
                                        </Typography>
                                        {user.phone && (
                                          <Typography
                                            component="span"
                                            variant="body2"
                                            color="text.primary"
                                          >
                                            {user.phone}
                                          </Typography>
                                        )}
                                      </>
                                    }
                                  />
                                </ListItem>
                              ))}
                            </Box>
                          ))}

                        </List>
                      </Paper>
                    </>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </DashboardLayout>
  );
};

export default index;